/** Compact annotation list row metrics (matches quick-action-toolbar.css). */
export const EEG_ANNOTATION_ROW_HEIGHT_PX = 22;
export const EEG_ANNOTATION_ROW_GAP_PX = 1;
export const EEG_ANNOTATION_LIST_VISIBLE_ROWS = 15;

export function computeAnnotationListViewportHeightPx(
  visibleRows: number = EEG_ANNOTATION_LIST_VISIBLE_ROWS,
): number {
  return (
    visibleRows * EEG_ANNOTATION_ROW_HEIGHT_PX +
    Math.max(0, visibleRows - 1) * EEG_ANNOTATION_ROW_GAP_PX
  );
}

/** Initial pop-out height sized for 15 annotation rows plus chrome. */
export function computeCompactAnnotationToolbarPopoutHeightPx(): number {
  const listViewport = computeAnnotationListViewportHeightPx();
  const detachedHeaderPx = 33;
  const listTypeSelectorPx = 42;
  const customizeButtonPx = 26;
  const shellPaddingPx = 8;
  return (
    listViewport +
    detachedHeaderPx +
    listTypeSelectorPx +
    customizeButtonPx +
    shellPaddingPx
  );
}
